import axios from 'axios';
import i18n from '@/lib/i18n';

const STORAGE_KEYS = {
  SELECTED_TENANT: 'inmocms_selected_tenant',
  TENANT_CONFIG: 'inmocms_tenant_config',
  LAST_FETCH: 'inmocms_tenant_last_fetch',
} as const;

// Create axios instance with base configuration
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'https://api.redraiz.co/api/v1',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const token = localStorage.getItem('inmocms_auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
      const cachedConfig = localStorage.getItem(STORAGE_KEYS.TENANT_CONFIG);

    if(cachedConfig){
      config.headers['x-tenant-id'] = JSON.parse(cachedConfig || '{}')?.id;
    }

    // Idioma de contenido: la API resuelve el contenido traducible (títulos,
    // descripciones, secciones…) a este idioma con fallback a ES. Se envía como
    // ?lang= porque el navegador PROHÍBE fijar Accept-Language por JS. Cubre
    // todas las llamadas sin tocar cada servicio.
    const lang = (i18n.language || 'es').split('-')[0];
    config.params = { ...(config.params || {}), lang };

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;